<template>
  <hr-info-banner
    :message="$t('premiumUpgrade.upgradeHint')"
    multi-line
    class="q-mb-md"
  >
    <template
      v-if="!noAction"
      #action
    >
      <hr-supporting-btn
        :label="$t('premiumUpgrade.upgradeBtn')"
        :to="{name: 'Settings - Subscription'}"
      />
    </template>
  </hr-info-banner>
</template>

<script>
import {
  HrInfoBanner,
  HrSupportingBtn,
} from 'src/design-system';

export default {
  name: 'PremiumBanner',

  components: {
    HrInfoBanner,
    HrSupportingBtn,
  },

  props: {
    noAction: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
